import { useMemo, useState } from 'react'

import { emptyDashboard } from './consts'
import { DashboardModalsContext } from './context'

export const DashboardModalsProvider = ({ children }) => {
  const [dashboard, setDashboard] = useState(emptyDashboard)
  const [folder, setFolder] = useState(null)
  const [isCreateDashboardModalOpen, setIsCreateDashboardModalOpen] = useState(false)
  const [isEditDashboardModalOpen, setIsEditDashboardModalOpen] = useState(false)
  const [isDeleteDashboardModalOpen, setIsDeleteDashboardModalOpen] = useState(false)
  const [isCreateDashboardFolderOpen, setIsCreateDashboardFolderOpen] = useState(false)
  const [isDeleteDashboardFolderOpen, setIsDeleteDashboardFolderOpen] = useState(false)
  const [isEditDashboardFolderOpen, setIsEditDashboardFolderOpen] = useState(false)
  const [isSelectDashboardFolderModalOpen, setIsSelectDashboardFolderModalOpen] = useState(false)
  const [createDashboardStep, setCreateDashboardStep] = useState(1)

  const dashboardValues = useMemo(
    () => ({
      dashboard,
      setDashboard,
      isCreateDashboardModalOpen,
      setIsCreateDashboardModalOpen,
      isEditDashboardModalOpen,
      setIsEditDashboardModalOpen,
      isDeleteDashboardModalOpen,
      setIsDeleteDashboardModalOpen,
      createDashboardStep,
      setCreateDashboardStep,
      isCreateDashboardFolderOpen,
      setIsCreateDashboardFolderOpen,
      folder,
      setFolder,
      isDeleteDashboardFolderOpen,
      setIsDeleteDashboardFolderOpen,
      isEditDashboardFolderOpen,
      setIsEditDashboardFolderOpen,
      isSelectDashboardFolderModalOpen,
      setIsSelectDashboardFolderModalOpen,
    }),
    [
      createDashboardStep,
      dashboard,
      isCreateDashboardModalOpen,
      isDeleteDashboardModalOpen,
      isEditDashboardModalOpen,
      isCreateDashboardFolderOpen,
      setIsCreateDashboardFolderOpen,
      folder,
      setFolder,
      isDeleteDashboardFolderOpen,
      setIsDeleteDashboardFolderOpen,
      isEditDashboardFolderOpen,
      setIsEditDashboardFolderOpen,
      isSelectDashboardFolderModalOpen,
      setIsSelectDashboardFolderModalOpen,
    ]
  )

  return <DashboardModalsContext.Provider value={dashboardValues}>{children}</DashboardModalsContext.Provider>
}
